/**
 * 全局登录过期提示状态管理
 * 用于防止多个请求同时返回401时重复弹出登录提示
 */

// 全局登录过期提示状态
let isReloginShowing = false;
let isLoggingOut = false;
let onReloginCallback = null;

/**
 * 检查是否可以显示登录提示
 * @returns {boolean} 如果可以显示返回true，否则返回false
 */
export function canShowRelogin() {
  // 如果已经有弹框在显示，不再弹出
  if (isReloginShowing) {
    return false;
  }

  // 主动退出登录期间，未完成的请求返回 401 属于预期，不弹框
  if (isLoggingOut) {
    return false;
  }

  // 如果当前路径是登录页面，不弹出弹框
  // 路由为 hash 模式，登录页体现在 hash 上而非 pathname
  const currentPath = window.location.hash.replace(/^#/, '') || window.location.pathname;
  const loginPaths = ['/login', '/auth-redirect', '/bind', '/register'];
  if (loginPaths.some(path => currentPath.startsWith(path))) {
    return false;
  }

  return true;
}

/**
 * 标记是否处于主动退出登录流程中
 * @param {boolean} loggingOut
 */
export function setLoggingOut(loggingOut) {
  isLoggingOut = loggingOut;
}

/**
 * 设置登录提示显示状态
 * @param {boolean} showing - 是否正在显示
 */
export function setReloginShowing(showing) {
  isReloginShowing = showing;
}

/**
 * 重置登录提示状态（用于登录成功后重置状态）
 */
export function resetReloginState() {
  isReloginShowing = false;
  isLoggingOut = false;
}

/**
 * 向后兼容的 isRelogin 对象
 * 用于保持与旧代码的兼容性
 */
export const isRelogin = {
  get show() {
    return isReloginShowing;
  },
  set show(value) {
    isReloginShowing = value;
  }
};

/**
 * 注册重新登录回调
 * @param {Function} callback - 回调函数
 */
export function registerReloginCallback(callback) {
  onReloginCallback = callback;
}

/**
 * 触发重新登录
 */
export function triggerRelogin() {
  if (onReloginCallback && canShowRelogin()) {
    setReloginShowing(true);
    onReloginCallback();
  }
}

/**
 * 获取当前是否正在显示重新登录提示
 */
export function getReloginShowing() {
  return isReloginShowing;
}
